var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-title',{staticClass:"justify-space-between"},[_c('div',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.count))])])}
var staticRenderFns = []

export { render, staticRenderFns }